import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { useOptionalActivityContext } from "../activity-context";

interface NoteChunkProps {
  change: ActivityChange;
}

export function NoteChunk({ change }: NoteChunkProps) {
  const ctx = useOptionalActivityContext();

  const handleViewComment = () => {
    const noteId = change.newValue?.value;
    if (noteId && ctx?.scrollToNote) {
      ctx.scrollToNote(noteId);
    }
  };

  return (
    <Text size="sm">
      {change.action} a comment
      {change.action !== "deleted" ? (
        <Text size="sm">
          {" "}
          {/* Inline pressable Text (a span) — never a Button, which is a flex
              box and would break out of this sentence onto its own line. */}
          <Text
            size="sm"
            variant="primary"
            className="cursor-pointer select-none"
            onClick={handleViewComment}
          >
            View comment
          </Text>
        </Text>
      ) : null}
    </Text>
  );
}
